import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./central-cliente-listar/central-cliente-listar.module').then(m => m.CentralClienteListarModule) },
    { path: 'editar', data: { breadcrumb : 'Editar' }, loadChildren: () => import('./central-cliente-editar/central-cliente-editar.module').then(m => m.CentralClienteEditarModule) },
    { path: 'ficha', data: { breadcrumb : 'Ficha' }, loadChildren: () => import('./central-cliente-ficha/central-cliente-ficha.module').then(m => m.CentralClienteFichaModule) },
    { path: 'retorno', data: { breadcrumb : 'Retornos' }, loadChildren: () => import('./central-cliente-retorno/central-cliente-retorno.module').then(m => m.CentralClienteRetornoModule) },
    { path: 'pacote', data: { breadcrumb : 'Pacotes' }, loadChildren: () => import('./central-cliente-pacote/central-cliente-pacote.module').then(m => m.CentralClientePacoteModule) },
    { path: 'pacote/cliente', data: { breadcrumb : 'Pacotes do Cliente' }, loadChildren: () => import('./central-cliente-pacotes-cliente/central-cliente-pacotes-cliente.module').then(m => m.CentralClientePacotesClienteModule) },
    { path: 'conta', data: { breadcrumb : 'Contas' }, loadChildren: () => import('./central-cliente-conta/central-cliente-conta.module').then(m => m.CentralClienteContaModule) }



  ])],
  exports: [RouterModule]
})
export class CentralClienteRoutingModule { }
